import { Shark } from "shark-mvc";

import ContentViewBase from "../ContentViewBase";
import PlaceContent from "../../models/PlaceContent";

import templateContent from "./place-content.html";

import contentFinderComponent from "../../components/contentFinder/contentFinderComponent";
import customTagsComponent from "../../components/customTags/customTagsComponent";
import dashboardView from "../dashboard/dashboardView";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import placeContentManager from "../../controllers/placeContentManager";
import relatedLinksComponent from "../../components/relatedLinks/relatedLinksComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import userMetadataBoxComponent from "../../components/userMetadataBox/userMetadataBoxComponent";

class PlaceContentView extends ContentViewBase {
	constructor () {
		super("placeContentView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		if (Shark.$store.currContent) {
			waitBoxComponent.open();
			this.initMap();
			// else {
			// 	super.afterLoad();
			// }

			Shark.$store.currContent.on("coordsLatChanged", () => {
				const { currContent } = Shark.get();
				
				if (currContent && currContent.coordsLat.includes(",")) {
					const coordsParts = currContent.coordsLat.split(",");
					
					currContent.set({
						coordsLat: coordsParts[0].trim(),
						coordsLon: coordsParts[1].trim(),
					});
				}
			});
		}
	}

	beforeLoad () {
		super.beforeLoad(placeContentManager, PlaceContent);
		this.mapInitialized = false;
	}

	beforeUnload () {
		Shark.set({
			editContentGoBackPage: null,
		});
	}

	// This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
	//	https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
	calcCrowFlyDistance (lat1, lon1, lat2, lon2) {
		lat1 = parseFloat(lat1);
		lon1 = parseFloat(lon1);
		lat2 = parseFloat(lat2);
		lon2 = parseFloat(lon2);

		const R = 6371; // km
		const dLat = this.degToRad(lat2 - lat1);
		const dLon = this.degToRad(lon2 - lon1);
		lat1 = this.degToRad(lat1);
		lat2 = this.degToRad(lat2);

		const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		const d = R * c;

		return d;
	}

	degToRad (value) {
		return value * Math.PI / 180;
	}

	contentLoaded () {
		waitBoxComponent.open();
		this.initMap();
	}

	// coordsLatField_inputHandler () {
	// 	console.log(Shark.$store.currContent.coordsLat);
	// }

	deleteContent (guid) {
		waitBoxComponent.open();

		placeContentManager.delete({guid})
		.then(() => {
			waitBoxComponent.close();
			Shark.openPage(dashboardView, { urlSearchParams: null });
		});
	}

	init () {
		this.addComponents([contentFinderComponent, customTagsComponent, mainNavComponent, relatedLinksComponent, userMetadataBoxComponent, waitBoxComponent]);
		super.init();

		window.initMap = this.initMap.bind(this);

		const mapScript = document.createElement("script");
		mapScript.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCohuTW_jeAM51bG1pxSP0RUdp2ihz-rkw&callback=initMap";
		document.head.append(mapScript);
	}

	initMap () {
		const { currContent } = Shark.get();

		if (!this.mapInitialized && currContent && currContent.coordsLat && currContent.coordsLon && window.google) {
			this.mapInitialized = true;
			const position = { lat: parseFloat(currContent.coordsLat), lng: parseFloat(currContent.coordsLon) };

			const map = new window.google.maps.Map(document.querySelector("#map"), {
				center: position,
				zoom: 7,
			});

			new window.google.maps.Marker({
				map,
				position,
			});
		}

		super.afterLoadCommon();
		// Shark.render();
	}

	async retrieveHierarchy () {
		// Questa la dovremmo fare diventare "periodica" per cambi? Tipo una volta all'anno?
		const { currContent } = Shark.get();

		if (currContent) {
			let response = await fetch(`${Shark.$store.apiV2URL}/geonames/get-place-by-name/${currContent.title}`);
			let placeList = await response.json();
			console.log({placeList});

			if (placeList.data.totalResultsCount === 0) {
				if (confirm("Non ho trovato nulla col nome, procedo con la ricerca per coordinate?")) {
					response = await fetch(`${Shark.$store.apiV2URL}/geonames/get-places-by-coords/${currContent.coordsLat},${currContent.coordsLon}`);
					placeList = await response.json();
				}
			}

			if (placeList.data.geonames.length > 0) {
				placeList.data.geonames.forEach(place => place.distance = this.calcCrowFlyDistance(place.lat, place.lng, currContent.coordsLat, currContent.coordsLon));
				placeList.data.geonames.sort((a, b) => a.distance - b.distance);

				const placeNameList = placeList.data.geonames.map((item, index) => `${index}) ${item.countryName} - ${item.adminName1} - ${item.name} (${Shark.$store.numberFormatter.format(item.distance)}Km)`).join("\n");

				const placeIndex = parseInt(prompt("Inserisci il numero della tua scelta:\n\n" + placeNameList, 0) || -1);

				if (placeIndex < 0 || placeIndex >= placeList.data.length) {
					alert("Devi scegliere un numero compreso nell'intervallo, non posso proseguire!");
					return;
				}

				const place = placeList.data.geonames[placeIndex];
				console.log({place, placeList});
				
				const hierarchyResponse = await fetch(`${Shark.$store.apiV2URL}/geonames/get-place-hierarchy-by-id/${place.geonameId}&lang=it&username=dave75`);
				const hierarchyData = await hierarchyResponse.json();

				console.log({hierarchyData, placeList});

				const hierarchy = hierarchyData.data.map(item => ({ fcode: item.fcode, geonameId: item.geonameId, name: item.name}));//.join("\n");

				currContent.set({
					hierarchy,
				});

				console.log({currContent});
				Shark.render();
			}
		}
	}

	retrieveHierarchyBtn_clickHandler () {
		this.retrieveHierarchy();
	}

	async saveCurrContent () {
		await this.save();

		if (Shark.$store.editContentGoBackPage) {
			Shark.openPage(Shark.$store.editContentGoBackPage);
		}
		else {
			Shark.openPage(dashboardView);
		}
	}

	async saveCurrContentAndCreateNew () {
		await this.save();

		const referenceVolumes = Shark.$store.currContent.referenceVolumes;
		
		Shark.set({
			currContent: new PlaceContent({
				createdByGuid: Shark.$store.currUser.guid,
				referenceVolumes,
			}),
			isCreatingNewContent: true,
		});
		Shark.openPage(placeContentView, { urlSearchParams: null });
	}

	async save () {
		const currContent = Shark.get("currContent");

		if (currContent) {
			waitBoxComponent.open();

			placeContentManager.save(currContent)
			.then(async saveResponse => {
				console.log({saveResponse});

				const customTagSaveResult = await customTagsComponent.save();
				console.log({customTagSaveResult});

				waitBoxComponent.close();
			});
		}
	}
}

const placeContentView = new PlaceContentView();

Shark.registerView(placeContentView);

export default placeContentView;
